import React, { FC } from 'react';

import { PsychicCardStatusWrapper } from 'entities/PsychicCardStatusWrapper';
import { PsychicCardHeading } from 'entities/PsychicCardHeading';
import { PsychicCtaButtons } from 'entities/PsychicCtaButton';
import { HiatusBar } from 'entities/HiatusBar';
import { CommonSize } from 'constants/enums';

import MainImage from './MainImage';
import styles from './PsychicCardListSmall.module.scss';

import { ISmallListCard } from '../config/declarations';

const SmallCard: FC<ISmallListCard> = ({
  bootStatus,
  psychic,
  psychicFrame,
  positionInArray,
  linkProps,
  status,
  cta,
}) => (
  <li className={styles.card}>
    <div className={styles.first}>
      <MainImage
        psychic={psychic}
        psychicFrame={psychicFrame}
        positionInArray={positionInArray}
        linkProps={linkProps}
        styles={styles}
        size={CommonSize.SMALL}
      />
      <PsychicCardStatusWrapper
        status={status}
        psychic={psychic}
        psychicFrame={psychicFrame}
        className={styles.statusWrapper}
        size={CommonSize.SMALL}
      />
    </div>
    <div className={styles.second}>
      <PsychicCardHeading
        psychic={psychic}
        psychicFrame={psychicFrame}
        linkProps={linkProps}
        className={styles.heading}
        size="small"
      />
      <p className={styles.description}>
        {psychic.usp}
      </p>
    </div>
    {!psychic.onHiatus && (
      <PsychicCtaButtons
        bootStatus={bootStatus}
        className={styles.interaction}
        chatButton={cta.chatButton}
        talkButton={cta.talkButton}
        callbackButton={cta.callbackButton}
        inQueueButton={cta.inQueueButton}
        messageButton={cta.messageButton}
        psychicFrame={psychicFrame}
        psychic={psychic}
        shape="Oval"
      />
    )}
    <HiatusBar
      psychic={psychic}
      contentfulData={psychicFrame}
      className={styles.hiatus}
    />
  </li>
);

export default SmallCard;
